import { FC, useMemo } from 'react'
import ReactECharts from 'echarts-for-react'
import { DIAG_MODULES, DiagModuleKey, MODULE_WOW, fmtWow } from './config'

export interface RadarSeriesItem {
	key: string
	name: string
	color: string
	dashed?: boolean
	scores: Record<DiagModuleKey, number>
}

interface RadarChartProps {
	weights: Record<DiagModuleKey, number>
	series: RadarSeriesItem[]
}

/** 能力雷达：上=基础投入 右=服务质量 下=转化贡献 左=挽回成果，与 demo.html 保持一致 */
const RadarChart: FC<RadarChartProps> = ({ weights, series }) => {
	const option = useMemo(
		() => ({
			tooltip: {
				trigger: 'item' as const,
				formatter: (params: any) => {
					const p = Array.isArray(params) ? params[0] : params
					const color = p.color || p.data?.itemStyle?.color || '#999'
					const rows = DIAG_MODULES.map((m, i) => {
						const wow = MODULE_WOW[m.key] === null ? '-' : fmtWow(MODULE_WOW[m.key])
						return `<div style="display:flex;align-items:center;gap:10px;padding:3px 0;">
							<span style="display:inline-block;flex:0 0 auto;width:6px;height:6px;border-radius:50%;background:${color};"></span>
							<span style="flex:1;color:#6B7280;white-space:nowrap;">${m.name} ${
							weights[m.key]
						}% 环比 ${wow}</span>
							<b style="color:#1F2329;">${p.value[i]}</b>
						</div>`
					}).join('')
					return `<div style="font-weight:600;margin-bottom:4px;color:#1F2329;">${p.name}</div>${rows}`
				}
			},
			radar: {
				center: ['50%', '46%'],
				radius: '60%',
				splitNumber: 4,
				axisName: { color: '#6B7280', fontSize: 13, lineHeight: 18 },
				axisLine: { lineStyle: { color: '#E8EBEF' } },
				splitLine: { lineStyle: { color: '#E8EBEF' } },
				splitArea: { areaStyle: { color: ['transparent', '#FCFCFD'] } },
				indicator: DIAG_MODULES.map(m => ({
					name: `${m.name} ${weights[m.key]}%\n环比 ${
						MODULE_WOW[m.key] === null ? '-' : fmtWow(MODULE_WOW[m.key])
					}`,
					max: 100
				}))
			},
			series: [
				{
					type: 'radar' as const,
					symbolSize: 6,
					data: series.map(s => ({
						name: s.name,
						value: DIAG_MODULES.map(m => s.scores[m.key]),
						lineStyle: { color: s.color, width: 2, type: s.dashed ? 'dashed' : 'solid' },
						areaStyle: { color: s.color, opacity: 0.1 },
						itemStyle: { color: s.color }
					}))
				}
			]
		}),
		[weights, series]
	)

	return (
		<>
			<ReactECharts option={option} style={{ height: 320 }} notMerge />
			<div className="-mt-2 mb-[6px] flex flex-wrap justify-center gap-x-5 gap-y-1.5 text-[12px] text-[#6b7280]">
				{series.map(s => (
					<span key={s.key} className="inline-flex items-center gap-1.5">
						<i
							className="inline-block w-3.5"
							style={{
								borderTop: `2px ${s.dashed ? 'dashed' : 'solid'} ${s.color}`
							}}
						/>
						{s.name}
					</span>
				))}
				{series.length < 2 && <span className="text-[#a0a6b0]">点击下方客服可叠加对比</span>}
			</div>
		</>
	)
}

export default RadarChart
